module.exports = __webpack_public_path__ + "img/manta.3c964ea0.png";